export default "__VITE_ASSET__c8410dcf__"